import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import clsx from 'clsx';
import { useFormik } from 'formik';
import validator from 'validator';
import * as Yup from 'yup';
import { hashPasswordControl, requestNewPassword } from '../redux/AuthCRUD';
import Select from 'react-select';

const initialValues = {
  password: '',
  changepassword: '',
  passwordRenewalFrequency: '',
};

const selectOptions = [
  { value: 1, label: '1 Ay' },
  { value: 2, label: '2 Ay' },
  { value: 3, label: '3 Ay' },
  { value: 4, label: '4 Ay' },
  { value: 5, label: '5 Ay' },
  { value: 6, label: '6 Ay' },
];

const newPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required('Şifre zorunlu.')
    .test(
      'pass',
      'Lütfen geçerli bir şifre belirtin.',
      (val: any) =>
        val &&
        validator.isStrongPassword(val, {
          minLength: 6, // 8
          minLowercase: 1,
          minUppercase: 1,
          minNumbers: 1,
          minSymbols: 1,
          returnScore: undefined,
        }),
    ),
  changepassword: Yup.string()
    .required('Şifre onayı gerekli')
    .when('password', {
      is: (val: string) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf([Yup.ref('password')], 'Şifreleriniz uyuşmuyor.'),
    }),
  passwordRenewalFrequency: Yup.number().required('Bu alan zorunludur.'),
});

const getErrorMessage = (e: any, fallback = 'Bir hata oluştu. Lütfen tekrar deneyin.') =>
  e?.response?.data?.message || e?.response?.data?.violations?.map((violation: any) => violation.title).join('\n') || fallback;

export function NewPassword() {
  let { hash }: any = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined);
  const [isResetSuccess, setIsResetSuccess] = useState(false);
  const [isHashValid, setIsHashValid] = useState(false);

  useEffect(() => {
    let isActive = true;
    setIsHashValid(false);

    if (!hash) {
      toast.error('Geçersiz şifre sıfırlama bağlantısı.');
      history.replace('/auth/login');
      return;
    }

    hashPasswordControl(hash)
      .then((res) => {
        if (!isActive) return;
        if (res?.data?.valid) {
          setIsHashValid(true);
          return;
        }
        toast.error(res?.data?.message || 'Geçersiz şifre sıfırlama bağlantısı.');
        history.replace('/auth/login');
      })
      .catch((e: any) => {
        if (!isActive) return;
        toast.error(getErrorMessage(e));
        history.replace('/auth/login');
      });

    return () => {
      isActive = false;
    };
  }, [hash, history]);

  const formik = useFormik({
    initialValues,
    validationSchema: newPasswordSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      setHasErrors(undefined);
      await requestNewPassword(values.password, Number(values.passwordRenewalFrequency), hash)
        .then((res) => {
          setHasErrors(false);
          setLoading(false);
          setIsResetSuccess(true);
          toast.success(res?.data?.message || 'Parolanız başarıyla sıfırlandı.');
          history.push('/auth/login');
        })
        .catch((e: any) => {
          toast.error(getErrorMessage(e));
          setHasErrors(true);
          setLoading(false);
          setSubmitting(false);
        });
      setLoading(false);
    },
  });

  if (!isHashValid) {
    return (
      <div className="d-flex justify-content-center align-items-center py-20">
        <span className="spinner-border text-primary" role="status" aria-label="Bağlantı doğrulanıyor" />
      </div>
    );
  }

  return (
    <>
      <form className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework" noValidate id="kt_login_password_reset_form" onSubmit={formik.handleSubmit}>
        <div className="text-center mb-10">
          {/* begin::Title */}
          <h1 className="text-dark mb-3">Şifremi Sıfırla</h1>
          {/* end::Title */}

          {/* begin::Link */}
          {/* end::Link */}
        </div>

        {/**
          {hasErrors === false && (
          <div className="mb-10 bg-light-success p-8 rounded">
          <div className="text-success">Parolanız başarıyla sıfırlandı.</div>
          </div>
        )}
         */}

        {/* end::Title */}

        {/* begin::Form group */}
        <div className="fv-row mb-10">
          <label className="form-label fw-bolder text-gray-900 fs-6">Şifre</label>
          <input
            type="password"
            placeholder="Şifre"
            autoComplete="off"
            {...formik.getFieldProps('password')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              { 'is-invalid': formik.touched.password && formik.errors.password },
              {
                'is-valid': formik.touched.password && !formik.errors.password,
              },
            )}
          />
          {formik.touched.password && formik.errors.password && (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">
                <span className="text-danger" role="alert">
                  {formik.errors.password}
                </span>
              </div>
            </div>
          )}
        </div>
        <div className="fv-row mb-10">
          <label className="form-label fw-bolder text-gray-900 fs-6">Şifre Doğrula</label>
          <input
            type="password"
            placeholder="Şifre Tekrar"
            autoComplete="off"
            {...formik.getFieldProps('changepassword')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              { 'is-invalid': formik.touched.changepassword && formik.errors.changepassword },
              {
                'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
              },
            )}
          />
          {formik.touched.changepassword && formik.errors.changepassword && (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">
                <span className="text-danger" role="alert">
                  {formik.errors.changepassword}
                </span>
              </div>
            </div>
          )}
        </div>
        <div className="row align-items-center mb-10">
          <div className="col-lg-12 form-label fw-bolder text-gray-900 fs-6 mb-2">Periyot</div>
          <div className="col-lg-12">
            <Select
              className={` w-100 h-100  fw-normal ${formik.values.passwordRenewalFrequency ? null : 'border-danger'}`}
              placeholder="Şifre periyodunu seçin"
              options={selectOptions}
              onChange={(e: any) => formik.setFieldValue('passwordRenewalFrequency', e.value)}
              styles={{
                control: (base) => ({ ...base, backgroundColor: '#f8f9fa', border: 'none', }),
                menu: (base) => ({ ...base, backgroundColor: '#ffffff', }),
              }}
            />
          </div>
        </div>
        {formik.touched.passwordRenewalFrequency && formik.errors.passwordRenewalFrequency && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <span className="text-danger" role="alert">
                {formik.errors.passwordRenewalFrequency}
              </span>
            </div>
          </div>
        )}
        {/* end::Form group */}
        <div className="row align-items-center mb-10 border pt-4 rounded">
          <div className="col-lg-12">
            <label className="fw-bold fs-6">Şifreniz aşağıda yer alan kriterlere uymalıdır;</label>
          </div>
          <div className="col-lg-12 mt-5 r">
            <ul>
              <li>Şifre en az 6 karakterden oluşmalıdır.</li>
              <li>Şifre en az bir rakam içermelidir.</li>
              <li>Şifre en az bir büyük, bir küçük harf içermelidir.</li>
              <li>Şifre en az bir özel karakter içermelidir.</li>
            </ul>
          </div>
        </div>
        {/* begin::Form group */}
        <div className="d-flex flex-wrap justify-content-center pb-lg-0">
          <button type="submit" id="kt_password_reset_submit" className="btn btn-lg btn-primary fw-bolder me-4" disabled={loading || formik.isSubmitting || !formik.isValid || isResetSuccess}>
            {!loading && <span className="indicator-label">Sıfırla</span>}
            {loading && (
              <span className="indicator-progress" style={{ display: 'block' }}>
                Lütfen bekleyin...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </button>
          <Link to="/auth/login">
            <button type="button" id="kt_login_password_reset_form_cancel_button" className="btn btn-lg btn-light-primary fw-bolder">
              İptal
            </button>
          </Link>{' '}
        </div>
        {/* end::Form group */}
      </form>
    </>
  );
}
